import { apiClient } from './api';
import { Appointment } from '../types';

class AppointmentService {
  async getAppointments(view?: 'upcoming' | 'past'): Promise<Appointment[]> {
    return apiClient.get<Appointment[]>('/member/appointments', { view });
  }
}

export const appointmentService = new AppointmentService();
